<template>
    <div class="col">
    <div class="list-group card-item" ref="lightItem" style="border-radius: 1.2rem;" @click="onLightPowerClicked" v-touch:press="onTouchDown" v-touch:drag="onTouchDrag" v-touch:release="onTouchRelease" v-touch:hold="onTouchHold">
      <div class="list-group-item d-flex align-items-center" :style="`height: 4rem; padding: 2px 0px; background: ${deviceState(1) ? `linear-gradient(to right, #ffe082 ${percent}%, #fff8e1 ${percent}%)` : 'inherits'};`">
        <i class="fa-regular fa-lightbulb ms-3 me-2" />
        <div class="flex-fill" style="font-size: 0.8rem">
          조명
          <br>
          {{ deviceState(1) ? currentBrightText : "" }}
        </div>
        <!-- <div class="mx-1" @click.stop="onLightInfoClicked">
          <i class="fa fa-ellipsis" />
        </div> -->
        <div class="mx-0 h-100" @click.stop="onSettingClicked">
          <i class="fa-solid fa-gear" style="font-size: 0.8rem; margin-top: 24px; width:40px; text-align: center" />
        </div>
        <!-- <div :style="`min-width:1px; height: 20px; border-left: 1px solid ${getPower ? '#ffd082;' : '#eeeeee;'}`" /> -->
        <div class="mx-0 h-100" v-if="lightDevices.length > 0" @click.stop.prevent="onExpandClicked">
          <i :class="`fa ${isExpand ? 'fa-chevron-up' : 'fa-chevron-down'}`" style="font-size: 0.8rem; margin-top: 24px; width:40px; text-align: center" />
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="isExpand">
        <RoomLightDeviceItem v-for="device in realDevices" :key="device._id" :roomName="props.roomName" :roomId="props.roomId" :deviceId="device._id" />
        <RoomLightDeviceItem v-for="device in virtualDevices" :key="device._id" :roomName="props.roomName" :roomId="props.roomId" :deviceId="device._id" />
      </div>
    </transition>
    <!-- <div class="list-group" ref="lightItem" style="border-radius: 1.2rem;" v-else @click="onLightPowerClicked" @mousedown="onMouseDown" v-touch:press="onTouchDown">
      <div class="list-group-item d-flex align-items-center" :style="`height: 4rem; background: ${deviceState(1) ? `linear-gradient(to right, #ffe082 ${percent}%, #fff8e1 ${percent}%)` : 'inherits'};`">
        <div class="flex-fill" style="font-size: 0.8rem">
          <i class="fa-regular fa-lightbulb me-2" />
          {{ props.roomName }} 조명 {{ deviceState(1) ? currentBrightText : "" }}
        </div>
        <div class="ms-3" @click.stop="onLightInfoClicked">
          <i class="fa fa-chevron-right" style="font-size: 0.8rem" />
        </div>
      </div>
    </div> -->
    </div>
    <LightItemModal
      v-if="lightItemModal.visible"
      :visible="lightItemModal.visible"
      :cancelCallback="lightItemModal.hide"
      :roomName="props.roomName"
      :roomId="props.roomId"
      :handlePowerClick="onLightPowerClicked"
    />
</template>

<script setup>
import { reactive, defineProps, getCurrentInstance, computed, onMounted, watch, ref } from 'vue';
import { useStore } from 'vuex';
import { DeviceType, PowerState, ButtonConfig } from '@/common/constants';
import { supportsLampCmdCs, findControllerInZone } from '@/common/utils/controllerDisplayName';
import Axios, { VirtualDeviceApi } from '@/api';
import LightItemModal from './LightItemModal.vue';
import useModal from '@/common/hooks/useModal';
import useMqttControl from '@/common/hooks/useMqttControl';
import useDeviceTouch from '@/common/hooks/useDeviceTouch';
import RoomLightDeviceItem from './RoomLightDeviceItem.vue';

const mqttControl = reactive(useMqttControl());
const emit = defineEmits(['onPowerClicked']);
const props = defineProps(['roomId', 'roomName']);
const store = useStore();
const lightItemModal = reactive(useModal());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const lightItem = ref(null);
const percent = ref(0.0);
const currentBright = ref(0);
const isExpand = ref(false);
const touchStartX = ref(0);
const touchStartY = ref(0);
const isScrollGesture = ref(false);
const { 
  handlePower, 
  handleTouchDown, 
  handleTouchDrag, 
  handleTouchRelease,
  handleTouchHold
} = useDeviceTouch(props.roomId);

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id === props.roomId);
});
const devices = computed(() => {
  return group.value ? group.value.devices : undefined;
});

const lightDevices = computed(() => {
  return devices.value.filter(
    (d) => d.type === 1,
  );
});
const realDevices = computed(() => {
  return devices.value.filter(
    (d) => d.type === 1 && !d.isVirtual,
  );
});
const virtualDevices = computed(() => {
  return devices.value.filter(
    (d) => d.type === 1 && d.isVirtual,
  );
});

const lampView = (d) => {
  const flat = d?.item ?? {};
  if (d?.onVirtual === true) {
    const st = flat?.state ?? {};
    // 대표버튼 UI: item.state 만 사용 (vc로 켜진 item.onoff 로 fallback 하지 않음)
    return {
      onoff: st?.onoff ?? 0,
      bright: st?.bright ?? flat?.bright ?? 0,
      color: st?.color ?? flat?.color ?? 0,
    };
  }
  return {
    onoff: flat?.onoff ?? 0,
    bright: flat?.bright ?? 0,
    color: flat?.color ?? 0,
  };
};

const lightBright = computed(() => {
  if (realDevices.value.length === 0) {
    return 0;
  }

  let bright = 0;
  realDevices.value.forEach((device) => {
    const v = lampView(device);
    if (v.bright > bright) {
      bright = v.bright;
    }
  });
  return bright;
});
const lightColor = computed(() => {
  if (realDevices.value.length === 0) {
    return 0;
  }

  let color = 0;
  realDevices.value.forEach((device) => {
    const v = lampView(device);
    if (v.color > color) {
      color = v.color;
    }
  });
  return color;
});

const getPower = computed(() => {
  return realDevices.value.some((d) => lampView(d).onoff === PowerState.On);
});

const currentBrightText = computed(() => {
  return `${parseInt(lightBright.value)}%`;
})

watch(lightBright, () => {
  currentBright.value = lightBright.value;
  percent.value = (lightBright.value - 10) / 90 * 100;
})

onMounted(() => {
  currentBright.value = lightBright.value;
  percent.value = (currentBright.value - 10) / 90 * 100;
});

const deviceState = (type) => {
  return realDevices.value
    .filter((d) => d.type === type)
    .some((d) => lampView(d).onoff === PowerState.On);
};

const onLightPowerClicked = (e) => {
  handlePower(() => {
    if (zone.value.isEditMode) {
      emitter.emit('showPopAlert', {
        description: '세팅중인 영역의 단말은 제어 할 수 없습니다.',
      });
      return;
    }
    emit('onPowerClicked', {
      id: props.roomId,
      type: 1,
      onoff: getPower.value ? PowerState.Off : PowerState.On,
    });
  });
};

const onLightInfoClicked = (e) => {
  if (zone.value.isEditMode) {
    emitter.emit('showPopAlert', {
      description: '세팅중인 영역의 단말은 제어 할 수 없습니다.',
    });
    return;
  }
  lightItemModal.show();
};

const onSettingClicked = (e) => {
  onLightInfoClicked();
}

const onExpandClicked = (e) => {
  isExpand.value = !isExpand.value;
}

const brightChange = async () => {
  if (zone.value.isEditMode) {
    emitter.emit('showPopAlert', {
      description: '세팅중인 영역의 단말은 제어 할 수 없습니다.',
    });
    return;
  }

  const devices = realDevices.value.filter(device => !device.isVirtual);

  emitter.emit('showLoading');

  const byController = {};
  for (const device of devices) {
    const cid = device.controllerId;
    if (!byController[cid]) {
      byController[cid] = { devices: [], ports: [] };
    }
    byController[cid].devices.push(device);
    const ports = device.item?.ports ?? [];
    byController[cid].ports.push(...(Array.isArray(ports) ? ports : [ports]));
  }

  for (const [controllerId, { devices: groupDevices }] of Object.entries(byController)) {
    const hasOnVirtual = groupDevices.some((d) => d?.onVirtual === true);
    const deviceIds = groupDevices.map((d) => d._id);
    const controller = findControllerInZone(zone.value?.controllers, controllerId);
    const useCs = supportsLampCmdCs(controller || controllerId);
    const bright = parseInt(currentBright.value);

    if (useCs) {
      const portsArr = [];
      const onoffArr = [];
      const brightArr = [];
      const colorArr = [];
      for (const device of groupDevices) {
        const ports = Array.isArray(device.item?.ports) ? device.item.ports : (device.item?.ports != null ? [device.item.ports] : []);
        const onoff = device.item?.onoff ?? 0;
        const color = device.item?.color ?? 0;
        for (const p of ports) {
          portsArr.push(p);
          onoffArr.push(onoff);
          brightArr.push(bright);
          colorArr.push(color);
        }
      }
      mqttControl.onPublishBatch(controllerId, deviceIds, {
        serial: controllerId,
        cmd: 'cs',
        type: DeviceType.Lamp,
        data: {
          ports: portsArr,
          onoff: onoffArr,
          bright: brightArr,
          color: colorArr,
        },
      }, { bright });
    } else {
      // 구형 등 cs 미지원 → 개별 cmd `c`
      for (const device of groupDevices) {
        const ports = Array.isArray(device.item?.ports)
          ? device.item.ports
          : (device.item?.ports != null ? [device.item.ports] : []);
        if (!ports.length) continue;
        mqttControl.onPublish(controllerId, device._id, {
          serial: controllerId,
          cmd: 'c',
          type: DeviceType.Lamp,
          data: {
            ports,
            onoff: device.item?.onoff ?? 0,
            bright,
            color: device.item?.color ?? 0,
          },
        });
      }
    }

    if (hasOnVirtual) {
      try {
        const result = await Axios.get(VirtualDeviceApi.VIRTUAL_DEVICES_BY_MEMBERS, {
          deviceIds: deviceIds.join(','),
        });
        const virtualDevices = result?.resultData || [];
        const virtualDeviceIds = new Set(virtualDevices.map((vd) => String(vd?._id)));
        const targetVirtualDevices = lightDevices.value.filter(
          (d) =>
            d?.isVirtual === true &&
            d?.item?.onoff === 1 &&
            virtualDeviceIds.has(String(d?._id)),
        );
        console.log(targetVirtualDevices);
        targetVirtualDevices.forEach((vd) => {
          store.commit('home/updateDevice', {
            groupId: props.roomId,
            id: vd._id,
            data: { item: { onoff: 0 } },
          });
        });
      } catch (err) {
        console.error('virtualDevices(byMembers) 조회 실패:', err);
      }
    }

    await sleep(50);
  }

  setTimeout(() => emitter.emit('hideLoading'), devices.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
};

const onTouchDown = (e) => {
  const clientX = e.targetTouches ? e.targetTouches[0]?.clientX : e.clientX;
  const clientY = e.targetTouches ? e.targetTouches[0]?.clientY : e.clientY;
  touchStartX.value = clientX;
  touchStartY.value = clientY;
  isScrollGesture.value = false;

  if (deviceState(1)) {
    handleTouchDown(e);
  }
}

const onTouchDrag = (e) => {
  const currentX = e.targetTouches ? e.targetTouches[0]?.clientX : e.clientX;
  const currentY = e.targetTouches ? e.targetTouches[0]?.clientY : e.clientY;
  const deltaX = Math.abs(currentX - touchStartX.value);
  const deltaY = Math.abs(currentY - touchStartY.value);
  if (deltaY > deltaX) {
    isScrollGesture.value = true;
    return;
  }

  handleTouchDrag(e, (screenX, startX) => {
    percent.value = percent.value + (screenX - startX) / lightItem.value.clientWidth * 100.0;
    percent.value = percent.value <= 0 ? 0 : percent.value;
    percent.value = percent.value >= 100 ? 100 : percent.value;
    currentBright.value = parseInt((9 * percent.value * 0.01) + 1) * 10;
  });
}

const onTouchRelease = (e) => {
  if (isScrollGesture.value) {
    handleTouchRelease(e, () => {}, { skipClickOnly: true });
  } else {
    handleTouchRelease(e, brightChange);
  }
}

const onTouchHold = (e) => {
  handleTouchHold(e, onLightInfoClicked);
}
</script>

<style scoped>
.card-item {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.card-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}
</style>